import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import useHelmet from 'components/common/useHelmet';
import { makeStyles, Typography } from '@material-ui/core';
import SeeAlso from 'components/articles/SeeAlso';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8, 0),
    width: 'auto',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(800 + theme.spacing(3) * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    flexGrow: 1,
    flexShrink: 0,
  },
  header: {
    marginBottom: theme.spacing(5),
  },
  content: {
    '& > img': {
      width: '100%',
      height: 'auto',
      maxWidth: 400,
      display: 'block',
      margin: theme.spacing(3, 'auto'),
    },
    '& ol, ul': {
      marginBlockStart: theme.spacing(3),
      marginBlockEnd: theme.spacing(3),
    },
    '& li + li': {
      marginTop: theme.spacing(1),
    },
  },
  seeAlso: {
    marginTop: theme.spacing(5),
  },
}));

function HowToArticle({ action, description, image, publishedTime, modifiedTime, children }) {
  const classes = useStyles();
  useHelmet(
    `How to ${action} an image online in 3 simple steps`,
    description,
    `https://photoutils.com/how-to-${action}-an-image-online`,
    {
      type: 'article',
      image,
      article: { published_time: publishedTime, modified_time: modifiedTime, author: 'https://twitter.com/photoutils' },
    }
  );

  return (
    <>
      <Header />
      <main className={classes.root}>
        <article>
          <Typography className={classes.header} variant="h4" component="h1" align="center">
            How to {action} an image online in 3 simple steps
          </Typography>
          <Typography variant="body1" component="div" className={classes.content}>
            {children}
            <SeeAlso without={action} className={classes.seeAlso} />
          </Typography>
        </article>
      </main>
      <Footer />
    </>
  );
}

export default HowToArticle;
